export default {
  submitReceive: '/v3/recruit/equipment/receive/affirm'
}
